var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-client-table',{staticClass:"v-table items__table",attrs:{"data":_vm.allItems,"columns":_vm.columns,"options":_vm.options}}),_c('InvoiceTotalAnalysis',{attrs:{"payload":_vm.invoice,"items":this.invoice.line_items,"hideForm":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }